export default __webpack_public_path__ + "static/bochnia-image-821321e33628b1368ded10e0579c01b3.jpg";